'use client';

import { useCallback, useState } from 'react';
import Image from 'next/image';

import ShortsModal from './shorts-modal';

function ShortCard({ item, index, onOpen }) {
	const label = `Assistir short: ${item.title}`;

	return (
		<article className="shortsSection__card">
			<button
				type="button"
				className="shortsSection__open"
				onClick={() => onOpen(index)}
				aria-label={label}
			>
				<span className="shortsSection__thumb" aria-hidden="true">
					<Image
						src={item.imageUrl}
						alt={item.title}
						width={220}
						height={394}
						sizes="(max-width: 767px) 42vw, 220px"
						quality={75}
						loading="lazy"
					/>
					<span className="shortsSection__play" aria-hidden="true" />
				</span>
				{item.channelTitle ? (
					<span className="shortsSection__channel">{item.channelTitle}</span>
				) : null}
				<span className="shortsSection__title">{item.title}</span>
			</button>
		</article>
	);
}

export default function ShortsSection({ items = [] }) {
	const [viewerOpen, setViewerOpen] = useState(false);
	const [viewerIndex, setViewerIndex] = useState(0);

	const openViewer = useCallback((index) => {
		setViewerIndex(index);
		setViewerOpen(true);
	}, []);

	if (!items.length) {
		return null;
	}

	return (
		<section className="ShortsSection" aria-label="Shorts">
			<div className="container">
				<div className="shortsSection__header">
					<span className="shortsSection__bar" aria-hidden="true" />
					<h2 className="shortsSection__heading">Shorts</h2>
				</div>
				<div className="shortsSection__grid">
					{items.map((item, index) => (
						<ShortCard
							key={item.id}
							item={item}
							index={index}
							onOpen={openViewer}
						/>
					))}
				</div>
			</div>
			<ShortsModal
				isOpen={viewerOpen}
				onClose={() => setViewerOpen(false)}
				items={items}
				initialIndex={viewerIndex}
			/>
		</section>
	);
}
